import { registerPlugin } from '@capacitor/core';

// Echo 플러그인 등록
var Echo = registerPlugin('Echo', {
  web: {
    echo: async function (options) {
      return { value: options.value };
    },

    getSystemBarInsets: async function () {
      return { statusBarHeight: 0, navBarHeight: 0 };
    },
  },
});

export default Echo;
